var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArticles = function SvgArticles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M5.25 5A.75.75 0 0 1 6 4.25h12.237a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75zm1.5.75v12.5h10.737V5.75z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M15.401 12.881H8.649v-1.5h6.752zM15.401 16.01H8.649v-1.5h6.752z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M11.455 7.551H8.65v2.806h2.806z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M15.401 9.454H12.48v-1.5H15.4z",
    clipRule: "evenodd"
  })));
};
export default SvgArticles;